import React, { Component } from 'react';
import Papa from 'papaparse';
import { Character } from './Character.js';

class Characters extends Component {

	constructor(props) {
		super(props);
		console.log(this.props.match.params);
		this.state = {count: false, equipment: false, luckyroll: false, modifiers: false, occupation: false, race: false};
	}

	componentWillMount() {
		var obj = this;
		var count = 4;
		
		if (this.props.match.params.count)
			count = this.props.match.params.count;
		this.setState({count: count});
		Papa.parse("equipment.csv", {
			download: true,
			delimiter: "\t",
			complete: function(results, file) {
				obj.setState({equipment: results.data});
			}
		});
		Papa.parse("equipment.csv", {
			download: true,
			delimiter: "\t",
			complete: function(results, file) {
				obj.setState({equipment: results.data});
			}
		});
		Papa.parse("luckyroll.csv", {
			download: true,
			delimiter: "\t",
			complete: function(results, file) {
				obj.setState({luckyroll: results.data});
			}
		});
		Papa.parse("modifiers.csv", {
			download: true,
			delimiter: "\t",
			complete: function(results, file) {
				obj.setState({modifiers: results.data});
			}
		});
		Papa.parse("occupation.csv", {
			download: true,
			delimiter: "\t",
			complete: function(results, file) {
				obj.setState({occupation: results.data});
			}
		});
		Papa.parse("race.csv", {
			download: true,
			delimiter: "\t",
			complete: function(results, file) {
				obj.setState({race: results.data});
			}
		});
	}
	
	renderCharacters() {
		var s = this.state;
		var characters = [];
		for (var i = 0; i < s.count; i++) {
			if (i > 0 && i % 4 === 0) {
			}
			characters.push(<Character key={i} equipment={s.equipment} luckyroll={s.luckyroll} modifiers={s.modifiers} occupation={s.occupation} race={s.race} />);
		}				
		return characters;
	}

	render() {
		var s = this.state;
		if (s.count && s.equipment && s.luckyroll && s.modifiers && s.occupation && s.race) {
			return (
			<div className="Characters">
				{ this.renderCharacters() }
			</div>
			);
		} else {
			return null;
		}
	}
}

export { Characters };



// WEBPACK FOOTER //
// ./src/components/Characters.js